import React from 'react';
import useTOCContext from './context';
import { treatSpaceOrEnterAsClick } from '~/helpers/events';
import RawHTML from '~/components/jsx-helpers/raw-html';
export default function TOCSlideout({ html }) {
    const { isOpen, toggle } = useTOCContext();
    return (React.createElement("div", { className: "toc-slideout" },
        React.createElement("div", { className: "top-padding" },
            React.createElement("span", { className: "close-toc", role: "button", tabIndex: 0, onClick: () => toggle(), onKeyDown: treatSpaceOrEnterAsClick, "aria-controls": "toc-drawer", "aria-expanded": isOpen }, "\u00D7")),
        React.createElement("div", { className: "toc-slideout-contents" },
            React.createElement("div", { id: "toc-drawer", className: "toc-drawer" }, isOpen && (React.createElement(RawHTML, { html: html, className: "table-of-contents" })))),
        React.createElement("div", { className: "bottom-padding" })));
}
